import { useEffect, useState } from "react";
import { GeminiAPI } from "../helper/GeminiAPI";

export default function LLMRecommendation({
  isOpen,
  onClose,
  selectedFile,
  listFileVulnerability,
}: any) {
  const [patch, setPatch] = useState<string | null>(null);
  const [aiResult, setAiResult] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [ReactMarkdown, setReactMarkdown] = useState<any>(null);

  useEffect(() => {
    async function loadMarkdown() {
      const mod = await import("react-markdown");
      setReactMarkdown(() => mod.default);
    }
    loadMarkdown();
  }, []);

  useEffect(() => {
    const file = listFileVulnerability.find(
      (file: any) => file.filename === selectedFile
    );
    if (file) setPatch(file.patch);
    else setPatch(null);
  }, [selectedFile, listFileVulnerability]);

  if (!isOpen) return null;

  const handleAskAI = async () => {
    setLoading(true);
    const response = await GeminiAPI(patch);
    console.log("AI Response:", response);
    setAiResult(response);
    setLoading(false);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative bg-black border-2 border-green-500 rounded-lg w-5/6 h-[90vh] shadow-2xl shadow-green-500/20 p-6 flex flex-col gap-6"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-2 right-4 text-green-400 hover:text-green-300 text-3xl font-mono"
          onClick={onClose}
        >
          ×
        </button>

        <h2 className="text-2xl font-bold text-green-400 font-mono tracking-wide">
          [ Vulnerability Patch Analysis ]
        </h2>

        <div className="h-[300px] border border-green-500/30 rounded p-4 overflow-y-auto bg-black text-sm whitespace-pre-wrap font-mono">
          {patch || "> No patch data available for this file."}
        </div>

        <div className="flex items-center justify-between">
          <h3 className="text-xl font-bold text-green-400 font-mono">
            &gt; AI Recommendation
          </h3>
          <button
            onClick={handleAskAI}
            disabled={loading}
            className="rounded px-4 py-2 bg-green-500 text-black font-mono font-bold hover:bg-green-400 disabled:opacity-50 transition-colors uppercase text-sm"
          >
            {loading ? "[ ANALYZING... ]" : "[ ASK AI ]"}
          </button>
        </div>

        {ReactMarkdown ? (
          <div className="markdown flex-1 border border-green-500/30 rounded p-4 overflow-y-auto bg-black text-sm  font-mono">
            <ReactMarkdown>
              {aiResult || "> Awaiting AI analysis..."}
            </ReactMarkdown>
          </div>
        ) : (
          <div className="text-green-400 font-mono">
            &gt; Loading markdown renderer...
          </div>
        )}
      </div>
    </div>
  );
}